export const getFileIconName = (fileExtension) => {
    fileExtension = fileExtension.toLowerCase();
    let returnVal = '';
    switch (fileExtension) {
        case 'pdf':
            returnVal = 'pdf-icon';
            break;
        case 'txt':
            returnVal = 'text-icon';
            break;
        case 'xls':
            returnVal = 'excel-icon';
            break;
        case 'xlsx':
            returnVal = 'excel-icon';
            break;
        case 'png':
            returnVal = 'image-icon';
            break;
        case 'jpg':
            returnVal = 'image-icon';
            break;
        case 'jpeg':
            returnVal = 'image-icon';
            break;
        case 'html':
            returnVal = 'html-icon';
            break;
        case 'pptx':
            returnVal = 'pptx-icon';
            break;
        default:
            returnVal = 'doc-icon';
            break;
    }
    return returnVal;
}